export const FAVICON_ICONS = [
  {
    rel: 'icon',
    name: 'favicon.svg',
    sizes: '',
    media: '',
    color: ''
  },
  {
    rel: 'shortcut icon',
    name: 'favicon.ico',
    sizes: '',
    media: '',
    color: ''
  },
  {
    rel: 'apple-touch-icon',
    name: 'apple-touch-icon.png',
    sizes: '',
    media: '',
    color: ''
  },
  {
    rel: 'mask-icon',
    name: 'mask-icon.svg',
    sizes: '',
    media: '',
    color: '#5bbad5'
  },
  {
    rel: 'link',
    name: 'manifest.json',
    sizes: '',
    media: '',
    color: ''
  },
  {
    rel: 'apple-touch-startup-image',
    name: 'app-loading-splash-320x460.png',
    sizes: '320x460',
    media: '(max-device-width: 480px) and not (-webkit-min-device-pixel-ratio: 2)',
    color: ''
  },
  {
    rel: 'apple-touch-startup-image',
    name: 'app-loading-splash-640x920.png',
    sizes: '640x920',
    media: '(max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2)',
    color: ''
  },
  {
    rel: 'apple-touch-startup-image',
    name: 'app-loading-splash-768x1004.png',
    sizes: '768x1004',
    media: 'screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait)',
    color: ''
  },
  {
    rel: 'apple-touch-startup-image',
    name: 'app-loading-splash-1024x748.png',
    sizes: '1024x748',
    media: 'screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape)',
    color: ''
  }
]
